import { IconProps } from './types';

export const CommentIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14.285 14.297'>
    <path
      // eslint-disable-next-line max-len
      d='M11.362,0H1.623A1.625,1.625,0,0,0,0,1.623v7.3A1.625,1.625,0,0,0,1.623,10.55H4.058v2.13a.305.305,0,0,0,.484.246L7.71,10.55h3.652a1.625,1.625,0,0,0,1.623-1.623v-7.3A1.625,1.625,0,0,0,11.362,0Z'
      transform='translate(0.65 0.65)'
      fill='none'
      stroke='#fff'
      strokeWidth='1.3'
      {...props}
    />
  </svg>
);
